<form *ngIf="!isLoading && languagesList && rolesList"
    [formGroup]="userForm" (submit)="onSubmit()" class="user-form">
    <mat-form-field>
        <mat-label>{{ 'users.editForm.username.label.shortLabel' | translate }}</mat-label>
        <input type="text" inputmode="email" matInput formControlName="username">
        <mat-error>{{ 'users.editForm.username.errorMessage.summary' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ 'users.editForm.email.label.shortLabel' | translate }}</mat-label>
        <input type="text" matInput formControlName="email">
        <mat-error>{{ 'users.editForm.email.errorMessage.summary' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ 'users.editForm.role.label.shortLabel' | translate }}</mat-label>
        <mat-select formControlName="role">
            <mat-option *ngFor="let role of rolesList" [value]="role.code">
                {{ role.text.shortLabel }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="canSelectProvider">
        <mat-label>{{ 'users.editForm.provider.shortLabel' | translate }}</mat-label>
        <mat-select formControlName="provider">
            <mat-option> - </mat-option>
            <mat-option *ngFor="let region of regionsList" [value]="region.provider.code">
                {{ region.text.shortLabel }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ 'main.languageSelector.shortLabel' | translate }}</mat-label>
        <mat-select formControlName="lang">
            <mat-option *ngFor="let language of languagesList" [value]="language.code">
                {{ language.codeISO }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <button *ngIf="!isLoading" type="submit" mat-icon-button color="accent" [disabled]="userForm.invalid">
        <mat-icon aria-label="Validate">check</mat-icon>
    </button>
    <button *ngIf="!isLoading" type="button" mat-icon-button (click)="onCancel()">
        <mat-icon aria-label="Cancel">clear</mat-icon>
    </button>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" ></mat-spinner>
